export const UNSET_BUSINESS_OFFERS = "businessOffers/UNSET_BUSINESS_OFFERS";

export const SET_BUSINESS_OFFERS = "businessOffers/SET_BUSINESS_OFFERS";
